export default __webpack_public_path__ + "static/top-firms-ad14aa29aa6efbb38a14600f36450c2c.png";